<template>
  <div>
    <div class="vue-step-wrapper">
      <vue-step
        style-type="style2"
        active-color="#4ce595"
        :now-step="4"
        :step-list="[
          $t('newAction.stepsLabels.selectMetric'),
          $t('newAction.stepsLabels.stepOne'),
          $t('newAction.stepsLabels.stepTwo'),
          $t('newAction.stepsLabels.stepThree'),
        ]"
      ></vue-step>
    </div>

    <div class="wrapper">
      <div class="row">
        <div class="col-12 mt-4">
          <idx-card class="mb-4" :title="`${this.$t('newAction.nameAction')}`">
            <input
              type="text"
              :value="action.name"
              id="action-name-id"
              class="form-control"
              disabled="disabled"
            />
          </idx-card>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h5>Link da pesquisa</h5>
          <p>
            Abaixo você verá uma prévia do link completo considerando os
            parâmetros criados. Os Parâmetros não são obrigatórios e caso você
            utilize o link sem essa informação, não será possível identificar o
            respondente da pesquisa.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 link-area">
          <button @click="copyUrl" class="btn btn-outline-primary">
            Copiar link
          </button>
          <span>{{ domainUrl }}</span>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <idx-card
            :title="`${this.$t('newAction.stepThree.titleIndicators')}`"
          >
            <div class="row mb-2 no-gutters">
              <div class="col-3">
                <label for
                  >{{ $t('newAction.stepThree.labels.addIndicators') }}:</label
                >
                <input
                  v-model="columnName"
                  type="text"
                  class="form-control mt-2"
                  :placeholder="`${this.$t(
                    'newAction.stepThree.enterIndicatorsName',
                  )}`"
                  @keyup.enter="addColumn"
                  :disabled="sending"
                />
              </div>
              <div class="col-9">
                <div class="drop-indicators">
                  <button
                    class="btn btn-primary"
                    style="margin-top: 39px;"
                    @click="addColumn"
                  >
                    {{ $t('newAction.stepThree.buttonAddColumn') }}
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <hr />
                <span>{{ $t('newAction.stepThree.addedIndicators') }}:</span>
                <table class="table table-striped mt-3">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t('newAction.stepThree.indicator') }}
                      </th>
                      <th
                        scope="col"
                        class="indicator-th"
                        v-for="(indicatorHeader, i) in indicatorHeaders"
                        :key="i"
                      >
                        {{ indicatorHeader.header }}
                        <span
                          :id="indicatorHeader.header"
                          class="indicator-info-icon"
                        >
                          <font-awesome-icon
                            :icon="['fas', 'info-circle']"
                            style="font-size: 15px; color: #c1c1c1;"
                          />
                        </span>
                        <b-popover
                          :target="indicatorHeader.header"
                          :title="indicatorHeader.header"
                          triggers="hover"
                          placement="top"
                          :content="indicatorHeader.content"
                        ></b-popover>
                      </th>
                      <th scope="col">
                        {{ $t('newAction.stepThree.remove') }}
                      </th>
                    </tr>
                  </thead>
                  <draggable
                    v-model="indicators"
                    tag="tbody"
                    id="dtable"
                    @change="handleSort"
                  >
                    <tr v-for="(indicator, index) in indicators" :key="index">
                      <td>
                        <font-awesome-icon
                          :icon="['fas', 'ellipsis-v']"
                          class="ellipsis"
                        />
                        {{ indicator.label }}
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('ih1', indicator.id, $event)"
                          v-model="indicator.ih1"
                          :disabled="
                            (allIh1Disabled && !indicator.ih1) ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('ih2', indicator.id, $event)"
                          v-model="indicator.ih2"
                          :disabled="
                            (allIh2Disabled && !indicator.ih2) ||
                            indicator.ih1 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="
                            indicatorRules('report', indicator.id, $event)
                          "
                          v-model="indicator.report"
                          :disabled="indicator.auxiliary || indicator.clientId"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('map', indicator.id, $event)"
                          v-model="indicator.map"
                          :disabled="
                            (allMapDisabled && !indicator.map) ||
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.date ||
                            indicator.auxiliary ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="indicatorRules('date', indicator.id, $event)"
                          v-model="indicator.date"
                          :disabled="
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          @input="
                            indicatorRules('auxiliary', indicator.id, $event)
                          "
                          v-model="indicator.auxiliary"
                          :disabled="
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.report ||
                            indicator.map ||
                            indicator.clientId
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          :onclick="
                            habilitAnonymous(indicator.id, indicator.clientId)
                          "
                          @input="
                            indicatorRules('clientId', indicator.id, $event)
                          "
                          v-model="indicator.clientId"
                          :disabled="
                            (allClientIdDisabled && !indicator.clientId) ||
                            indicator.ih1 ||
                            indicator.ih2 ||
                            indicator.map ||
                            indicator.date ||
                            indicator.auxiliary
                          "
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <b-form-checkbox
                          :disabled="indicator.clientId"
                          @input="
                            indicatorRules('anonymous', indicator.id, $event)
                          "
                          v-model="indicator.anonymous"
                        ></b-form-checkbox>
                      </td>
                      <td>
                        <button
                          @click="removeColumn(index, indicator.id)"
                          class="btn btn-outline-danger"
                        >
                          <font-awesome-icon :icon="['fa', 'trash-alt']" />
                        </button>
                      </td>
                    </tr>
                  </draggable>
                </table>
              </div>
            </div>
          </idx-card>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 footer-buttons-area">
          <button @click="$router.back()" class="btn btn-info">
            {{ $t('genericMessages.goBack') }}
          </button>
          <button @click="saveChanges" class="btn btn-info">
            {{ $t('newAction.stepOne.saveChanges') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import draggable from 'vuedraggable';
import swal from 'sweetalert';
import { mapActions, mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import vueStep from 'vue-step';
import MultipleFileUploader from '@updivision/vue2-multi-uploader';
import IdxCard from '@/components/molecules/idx-card';
import api from '../../../../services/api';
import EventBus from '../../../../eventBus';

const n = require('normalize-strings');

export default {
  components: { IdxCard, MultipleFileUploader, draggable, vueStep },

  computed: {
    ...mapFields('actions', ['action']),
    ...mapState('companies', ['company', 'myMetric']),
    ...mapState('indicators', ['actionIndicators']),
    ...mapFields('submit', ['columns']),

    domainUrl() {
      let domain = 'https://app-indecx.com';

      if (window.location.hostname === 'localhost') {
        domain = 'http://localhost:8080';
      } else if (window.location.hostname === 'indecx.pe') {
        domain = 'https://indecx.pe';
      } else if (window.location.hostname === 'stg.idcx-verse.com') {
        domain = 'https://stg.idcx-verse.com';
      }

      domain = `${domain}/${
        this.action.channel === 'totem' ? 'survey-totem' : 'survey-link'
      }/${this.action._id}`;

      this.params.forEach((el, index) => {
        if (index === 0) {
          domain = `${domain}?${el.name}=${el.value}`;
        } else {
          domain = `${domain}&${el.name}=${el.value}`;
        }
      });

      this.indicators.forEach((el) => {
        domain = `${domain}&${el.key}=${el.key}`;
      });

      return domain;
    },
  },

  data: () => ({
    loading: false,
    allIh1Disabled: false,
    allMapDisabled: false,
    allIh2Disabled: false,
    allClientIdDisabled: false,
    anonymousDisabled: false,
    sending: false,
    actionId: null,
    toastCount: 0,
    userAuth: null,
    columnName: null,
    indicators: [],
    fields: [],
    options: {
      ih: null,
      date: false,
      map: false,
      report: false,
      clientId: false,
    },
    ih1: false,
    ih2: false,
    indicatorHeaders: [],
    countryLanguage: 'pt',
    link: null,
    params: [
      { name: 'name', value: 'client' },
      { name: 'email', value: 'client@email.com' },
      { name: 'phone', value: '5519999999999' },
    ],
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    const response = await api.get(`/action/${this.$route.params.id}`, {
      headers: {
        'x-access-token': this.userAuth.token,
      },
    });

    this.action = {
      ...response.data,
    };

    await this.getIndicators({
      token: this.userAuth.token,
      actionId: this.action._id,
    });

    if (this.action._id) {
      this.checkIndicators();
    }

    this.indicatorHeaders = [
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.filial.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.filial.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.ih2.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.ih2.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.report.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.report.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.map.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.map.content'),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.date.header'),
        content: this.$t('newAction.stepThree.indicatorHeaders.date.content'),
      },
      {
        header: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.header',
        ),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.auxiliary.content',
        ),
      },
      {
        header: this.$t('newAction.stepThree.indicatorHeaders.clientId.header'),
        content: this.$t(
          'newAction.stepThree.indicatorHeaders.clientId.content',
        ),
      },
      {
        header: 'Anonimizar',
        content:
          'Ao selecionar você pode visualizar ou não os indicadores de respostas anonimas',
      },
    ];

    this.changeCalendarLanguage();
  },

  methods: {
    ...mapActions('indicators', [
      'setIndicators',
      'getIndicators',
      'addTypeToIndicator',
      'removeTypeFromIndicator',
      'sortIndicator',
      'deleteIndicator',
    ]),

    habilitAnonymous(indicatorId, clientIdEnabled) {
      if (clientIdEnabled) {
        this.indicators.forEach((el) => {
          if (el.id === indicatorId) {
            el.anonymous = true;
          }
        });
      }
    },

    async handleSort() {
      await this.sortIndicator({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        indicators: this.indicators,
      });
      this.loading = true;

      await this.getIndicators({
        token: this.userAuth.token,
        actionId: this.action._id,
      });

      await this.checkIndicators();
      this.loading = false;
    },

    async indicatorRules(type, indicatorId, isChecked) {
      if (indicatorId) {
        try {
          if (isChecked) {
            if (type === 'ih1') {
              this.allIh1Disabled = true;
            }

            if (type === 'map') {
              this.allMapDisabled = true;
            }

            if (type === 'ih2') {
              this.allIh2Disabled = true;
            }

            if (type === 'clientId') {
              this.allClientIdDisabled = true;
            }

            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }

            await this.addTypeToIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          } else {
            if (type === 'ih1') {
              this.allIh1Disabled = false;
            }

            if (type === 'map') {
              this.allMapDisabled = false;
            }

            if (type === 'ih2') {
              this.allIh2Disabled = false;
            }

            if (type === 'clientId') {
              this.allClientIdDisabled = false;
            }

            if (type === 'anonymous') {
              this.anonymousDisabled = false;
            }

            await this.removeTypeFromIndicator({
              token: this.userAuth.token,
              indicatorId,
              type,
            });
          }
        } catch (error) {
          const myIndicator = this.indicators.find(
            (el) => el.id === indicatorId,
          );

          myIndicator[type] = !isChecked;

          swal({
            title: this.$t('newAction.stepThree.messages.dangerMode.title'),
            text: this.$t(
              'newAction.stepThree.messages.dangerMode.description',
            ),
            icon: 'error',
            dangerMode: true,
          });
        }
      }
    },

    async addColumn() {
      const regex = /^(?=.*[.$])/; // mongo issue -> key does not allow "." or "$"
      if (this.columnName) {
        const item = this.indicators.find(
          (obj) => obj.label === this.columnName,
        );
        if (regex.test(this.columnName)) {
          this.makeToastInvalidName();
        } else if (
          !item &&
          this.columnName.toLowerCase() !== 'nome' &&
          this.columnName.toLowerCase() !== 'email' &&
          this.columnName.toLowerCase() !== 'telefone'
        ) {
          this.sending = true;

          try {
            this.loading = true;
            await this.setIndicators({
              token: this.userAuth.token,
              actionId: this.action._id,
              companyId: this.userAuth.companyId,
              data: {
                name: this.columnName,
              },
            });

            this.indicators.push({
              // eslint-disable-next-line
              key: n(this.columnName).toLowerCase().replace(/\ /gi, '_'),
              label: this.columnName,
              branch: this.options.ih,
              map: this.options.map,
              date: this.options.date,
              report: this.options.report,
              clientId: this.options.clientId,
              sortable: true,
              anonymous: this.options.anonymous,
            });

            await this.getIndicators({
              token: this.userAuth.token,
              actionId: this.action._id,
            });

            await this.checkIndicators();

            this.columnName = null;
            this.options.ih = null;
            this.options.map = false;
            this.options.date = false;
            this.options.report = false;
            this.options.clientId = false;
            this.options.anonymous = true;
            this.ih1 = false;
            this.ih2 = false;
            this.columns = this.fields;

            this.columns = this.columns.concat(this.indicators);
            this.loading = false;
          } catch (error) {
            window.console.log('houve um erro');
          }

          this.sending = false;
        } else {
          this.columnName = null;
          this.makeToastColumnName();
        }
      }
    },

    async removeColumn(index, indicatorId) {
      swal({
        title: this.$t('newAction.stepThree.messages.removeColumn.title'),
        text: this.$t('newAction.stepThree.messages.removeColumn.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          await this.deleteIndicator({
            token: this.userAuth.token,
            indicatorId,
          });

          await this.getIndicators({
            token: this.userAuth.token,
            actionId: this.action._id,
          });

          await this.checkIndicators();

          this.columns = this.fields.concat(this.indicators);

          swal({
            title: this.$t('newAction.stepThree.messages.success.title'),
            text: this.$t('newAction.stepThree.messages.success.description'),
            icon: 'success',
          });
        }
      });
    },

    async checkIndicators() {
      this.indicators = [];

      if (this.actionIndicators) {
        this.actionIndicators.forEach((el) => {
          if (
            el.key !== 'nome' &&
            el.key !== 'email' &&
            el.key !== 'telefone'
          ) {
            this.indicators.push({
              key: el.key,
              position: el.position,
              label: el.name,
              ih1: el.types.indexOf('ih1') === -1 ? false : true,
              ih2: el.types.indexOf('ih2') === -1 ? false : true,
              report: el.types.indexOf('report') === -1 ? false : true,
              map: el.types.indexOf('map') === -1 ? false : true,
              date: el.types.indexOf('date') === -1 ? false : true,
              auxiliary: el.types.indexOf('auxiliary') === -1 ? false : true,
              clientId: el.types.indexOf('clientId') === -1 ? false : true,
              anonymous:
                el.types.indexOf('anonymous') === -1
                  ? el.anonymous
                  : el.anonymous,
              id: el._id,
            });
          }
        });

        const ih1Exists = this.indicators.find((el) => el.ih1);

        if (ih1Exists) {
          this.allIh1Disabled = true;
        }

        const mapExists = this.indicators.find((el) => el.map);

        if (mapExists) {
          this.allMapDisabled = true;
        }

        const ih2Exists = this.indicators.find((el) => el.ih2);

        if (ih2Exists) {
          this.allIh2Disabled = true;
        }

        const clientIdExists = this.indicators.find((el) => el.clientId);

        if (clientIdExists) {
          this.allClientIdDisabled = true;
        }

        const anonymousIndicator = this.indicators.find((el) => el.anonymous);

        if (anonymousIndicator) {
          this.anonymousDisabled = false;
        }

        this.columns.splice(3);

        this.columns = this.columns.concat(this.indicators);
      }
    },

    dateFormat(param) {
      const date = format(param, 'dd/MM/yyyy');
      return date;
    },

    dateFormatSubmit(param) {
      const date = format(param, 'yyyy-MM-dd');
      return date;
    },

    makeToast(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errorMessage.description'),
        {
          title: this.$t('newAction.stepThree.messages.errorMessage.title'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },

    makeToastNumber(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidNumber'),
        {
          title: this.$t('newAction.stepThree.messages.errorMessage.title'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },

    makeToastColumnName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidColumn'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },

    makeToastInvalidName(append = false) {
      this.toastCount += 1;
      this.$bvToast.toast(
        this.$t('newAction.stepThree.messages.errors.invalidCharacters'),
        {
          title: this.$t('newAction.stepThree.titleAddIndicator'),
          autoHideDelay: 5000,
          appendToast: append,
        },
      );
    },

    changeCalendarLanguage() {
      switch (this.$i18n.locale) {
        case 'br':
          this.countryLanguage = 'pt';
          break;
        case 'co':
          this.countryLanguage = 'es';
          break;
        case 'us':
          this.countryLanguage = 'en';
          break;
        default:
          break;
      }
    },

    saveChanges() {
      swal({
        title: this.$t('newAction.stepOne.actionSavedAlert'),
        text: this.$t('newAction.stepThree.wish'),
        icon: 'success',
        buttons: {
          leave: {
            text: this.$t('newAction.stepThree.cancel'),
            value: 'cancel',
          },
          next: {
            text: this.$t('newAction.stepThree.continueAfter'),
            value: 'skip',
          },
        },
      }).then((value) => {
        if (value === 'skip') {
          this.$router.push('/action-list');
        }
      });
    },

    copyUrl() {
      const textArea = document.createElement('textarea');

      document.body.appendChild(textArea);
      textArea.value = this.domainUrl;
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);

      this.$bvToast.toast(
        'O link foi copiado para a sua área de transferência.',
        {
          title: 'Link copiado',
          autoHideDelay: 3000,
          variant: 'success',
          solid: true,
        },
      );
    },
  },

  async mounted() {
    EventBus.$on('changedLanguage', () => {
      this.changeCalendarLanguage();
    });

    this.$store.state.actions.clientsCount = 0;

    this.fields = [
      {
        key: 'nome',
        label: this.$t('newAction.stepThree.labels.personName'),
        sortable: true,
      },
      {
        key: 'email',
        label: this.$t('newAction.stepThree.labels.personEmail'),
        sortable: true,
      },
      {
        key: 'telefone',
        label: this.$t('newAction.stepThree.labels.personPhone'),
        sortable: true,
      },
    ];

    // this.link = `${this.domainUrl}/${this.action._id}?name=client&email=client@email.com&phone=5519999999999`;

    this.columns = this.fields;
  },
};
</script>

<style lang="scss">
.ellipsis {
  color: #c1c1c1;
}

.ellipsis:hover {
  cursor: all-scroll;
}

.drop-indicators .dropdown-menu {
  width: 100%;
}

.drop-indicators .btn-outline-primary {
  &:hover {
    color: #fff;
  }
}
</style>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.link-area {
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    margin-right: 16px;
    max-height: 40px;
  }

  span {
    flex: 1;
  }
}

td,
th {
  text-align: center;
}

td:first-child,
th:first-child {
  text-align: left;
}

.footer-buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.add-user {
  color: $primary;
  font-size: 21px;
  cursor: pointer;
}

.add-column-area {
  display: flex;
  flex-direction: row;
}

.wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 8px 24px;
  border-radius: 4px;
  margin: 8px;
}

.vue-step-wrapper {
  background-color: #fff;
  border: 1px solid $gray-light;
  padding: 0 24px;
  border-radius: 4px;
  margin: 8px 8px 16px;
}

button {
  &:hover {
    color: $white;
  }
}

.indicator-th {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/actions/step-three-link/index.vue